// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';

import Ref from 'models/propTypes/ref';
import { useRestoration } from 'hooks/restoration';

const withRestoration = getId => Component => {
  const HOC = ({ shouldCleanUp, forwardedRef, ...rest }) => {
    const restorationId = getId(rest);
    const { setRestorationState, restorationState } = useRestoration(
      restorationId,
      shouldCleanUp,
    );

    return (
      <Component
        {...rest}
        setRestorationState={setRestorationState}
        restorationState={restorationState}
        ref={forwardedRef}
      />
    );
  };

  // prettier-ignore
  HOC.displayName = `withRestoration(${
    Component.displayName || Component.name
  })`;

  HOC.propTypes = {
    shouldCleanUp: PropTypes.bool,
    forwardedRef: Ref,
  };

  HOC.defaultProps = {
    shouldCleanUp: false,
    forwardedRef: null,
  };

  return React.forwardRef((props, ref) => (
    <HOC {...props} forwardedRef={ref} />
  ));
};

export default withRestoration;
